import React from 'react';
import { useTranslation } from 'react-i18next';
import StakingModalShell from '../StakingModalShell';

const UnstakeRequestModal = ({ data, onClose, onSubmit }) => {
  const { t } = useTranslation();
  if (!data) return null;

  const footer = (
    <button
      type="button"
      className="staking-btn staking-btn-secondary staking-btn-block"
      onClick={onSubmit}
    >
      {t('staking.request', 'Request')}
    </button>
  );

  return (
    <StakingModalShell
      title={t('staking.unstake_request_title', 'Un-Stake Request')}
      onClose={onClose}
      footer={footer}
    >
      <div className="staking-modal-field">
        <span className="staking-modal-label">
          {t('staking.unstake_amount', 'Un-Stake amount')}
        </span>
        <span className="staking-modal-value">
          {data.amount} {data.tokenSymbol}
        </span>
      </div>
      <dl className="staking-breakdown">
        <div>
          <dt>{t('staking.unstake_fee', 'Un-Stake fee')}</dt>
          <dd>{data.fee}</dd>
        </div>
        <div>
          <dt>{t('staking.total_to_claim', 'Total to claim')}</dt>
          <dd>{data.totalClaim}</dd>
        </div>
      </dl>
    </StakingModalShell>
  );
};

export default UnstakeRequestModal;
